import ToastHighLighter from '@/lib/ToastHighLighter';

export const ToolsFooterCode = () => {
  const language = 'html';
  const name = 'toolsfooter';
  const codeString = `
  // Tools-Footer
  <footer id="footer">
    <div class="container tools__footer pt-4">
      <div class="row">
        <div class="d-flex justify-content-center">
          <p>
            <a href="https://www.fhnw.ch" target="_blank">
              www.fhnw.ch
            </a>
            <span class="d-inline-block mx-1 mx-md-2">|</span>
            <a href="#">Impressum</a>
            <span class="d-inline-block mx-1 mx-md-2">|</span>
            <a href="#">Datenschutz</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
  `;

  return (
    <>
      <ToastHighLighter
        name={name}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const WebdienstFooterCode = () => {
  const language = 'html';
  const name = 'toolsfooter';
  const codeString = `
  // Webdienst-Footer
  <footer id="footer">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4">
          <h4>Kontakt</h4>
          <p>
            Fachhochschule Nordwestschweiz FHNW
            <br />
            Institute
            <br />
            Division
            <br />
            Street<br />
            Zip Location
          </p>
          <p>
            E-Mail: <a href="mailto:#">E-Mail</a>
          </p>

          <!-- Social Media Icons -->
          ...
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 order-first order-md-0">
          <h4>Über diese Website</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae vel esse obcaecati minus!
            Aperiam quibusdam, voluptatem est recusandae neque veritatis sunt.
            Corporis quibusdam ad vitae consequuntur nemo, atque error iste.
          </p>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4">
          <h4>Quicklinks</h4>
          <p>
            <a href="#">
              Link
            </a>
            <br />
            <a href="#">Link</a>
            <br />
            <a href="#">
              Link
            </a>
            <br />
            <a href="#">Quicklinks</a>
          </p>
        </div>
      </div>
    </div>
    <div class="container tools__footer">
      <div class="row">
        <div class="d-flex justify-content-center">
          <p>
            <a href="https://www.fhnw.ch" target="_blank">
              www.fhnw.ch
            </a>
            <span class="d-inline-block mx-1 mx-md-2">|</span>
            <a href="#">Impressum</a>
            <span class="d-inline-block mx-1 mx-md-2">|</span>
            <a href="#">Datenschutz</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
  `;

  return (
    <>
      <ToastHighLighter
        name={name}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
